import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'config/i18n'; // Initialize i18n
import App from 'app/App';
import { store } from 'config/redux/store';
import { InstagramConnectionProvider } from 'contexts/InstagramConnectionContext';
import { ThemeProvider } from 'contexts/ThemeContext';
import { ErrorBoundary } from 'components/common/ErrorBoundary';
import reportWebVitals from 'config/reportWebVitals';
import { logger } from 'utils/logger';
import 'styles/global.css';

// Global last-resort safety net: catches errors that escape React's tree
// (async work, event handlers that swallow, dynamic imports) and funnels them
// through the same logger chokepoint so an external monitor can subscribe.
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    logger.error('unhandled-rejection', {
      reason: event.reason?.message ?? String(event.reason),
    });
  });
  window.addEventListener('error', (event) => {
    logger.error('window-error', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <ThemeProvider>
            <InstagramConnectionProvider>
              <App />
            </InstagramConnectionProvider>
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </GoogleOAuthProvider>
);

reportWebVitals(({ name, value, delta, id }) => logger.debug('web-vitals:', { name, value, delta, id }));